/**
 * Coerce decorator
 */
export function coerce(coerceFn, afterFn) {
    return function (target, propertyKey) {
        const _key = Symbol();
        target[_key] = target[propertyKey];
        Object.defineProperty(target, propertyKey, {
            get: function () {
                return this[_key];
            },
            set: afterFn
                ? function (v) {
                    this[_key] = coerceFn.call(this, v, this);
                    afterFn.call(this, this[_key], this);
                }
                : function (v) {
                    this[_key] = coerceFn.call(this, v, this);
                }
        });
    };
}
